//
//
//
//
//
//
//
//
//

import { PLUGIN_CATEGORIES } from "../../Diagram/const/plugin-categories";

export default {
    name: "PluginReadonlyContainer",
    props: {
        customSize: Object,
        pluginType: String
    },
    data() {
        return {
            previewInstance: null,
            plugin: null,
            allPlugins: PLUGIN_CATEGORIES,
            sizeCanvas: { width: 20, height: 20 } // default width / height
        };
    },
    watch: {
        pluginType: {
            handler(value) {
                this.allPlugins.forEach(categ => {
                    if (!categ.hasOwnProperty("displayPreview")) {
                        for (let i = 0; i < categ.plugins.length; i++) {
                            if (value === categ.plugins[i].id) {
                                this.plugin = categ.plugins[i];
                                this.drawPlugin();
                                break;
                            }
                        }
                    }
                });
            },
            immediate: true
        }
    },
    created() {
        if (this.customSize) {
            this.sizeCanvas = this.customSize;
        }
    },
    mounted() {
        this.drawPlugin();
    },
    methods: {
        drawPlugin() {
            if (this.$refs.canvas) {
                const Plugin = this.plugin.plugin;
                this.$refs.canvas.getContext("2d").clearRect(0, 0, this.sizeCanvas.width, this.sizeCanvas.height);
                this.$refs.canvas.getContext("2d").setTransform(1, 0, 0, 1, -0.5, -0.5);
                this.previewInstance = new Plugin(
                    {
                        position: {
                            x: 0,
                            y: 0
                        },
                        size: this.sizeCanvas
                    },
                    this.$refs.canvas.getContext("2d")
                );
                this.previewInstance.preview = true;
                this.previewInstance.draw();
            }
        }
    }
};
